import React, { useEffect, useState } from "react";
import ContentBox from "../ContentBox/ContentBox";
import { Chip, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import ButtonLoading from "../Button/ButtonLoading";
import _ from "lodash";
import { Add } from "@mui/icons-material";
import ApiClient from "../../services/ApiClient";
import { BeaAttachmentFilter as BeaAttachmentFilterType } from "../../types/Bea/BeaAttachmentFilter";

export default function BeaAttachmentFilter() {
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState<string[]>([]);
  const [registryEntryIri, setRegistryEntryIri] = useState("");
  const [initialFilters, setInitialFilters] = useState<string[]>([]);
  const [newFilter, setNewFilter] = useState("");

  useEffect(() => {
    fetchFilters()
      .then((result) => {
        const sortedResult = _.sortBy(result);
        setInitialFilters(sortedResult);
        setFilters(sortedResult);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSaveFilters = () => {
    setIsLoading(true);

    const payload = {
      registryValue: JSON.stringify(filters),
    };

    ApiClient.patch(registryEntryIri, { body: JSON.stringify(payload) }).then(() => {
      setIsLoading(false);
    });
  };

  const fetchFilters = async (): Promise<string[]> => {
    const resultCollection = await ApiClient.get("registry_entries?registryKey=beaAttachmentFilters");
    const entry: BeaAttachmentFilterType = _.head(resultCollection["hydra:member"])!;
    setRegistryEntryIri(entry["@id"]);
    const filters = entry["registryValue"];
    return JSON.parse(filters);
  };

  const removeFilter = (filterToRemove: string) => {
    setFilters(_.filter(filters, (filter) => filter !== filterToRemove));
  };

  const addFilter = () => {
    setFilters(_.sortBy([...filters, newFilter]));
    setNewFilter("");
  };

  return (
    <ContentBox>
      <Typography>
        Hier bitte die Wörter eingeben, nach denen unser System Anhänge ausfiltern soll. Anhänge die diese Wörter
        enthalten, sind dann nicht mehr im Tool "beA-Anlagen" sichtbar.
        <br />
        <br />
        Beispiel: pruefvermerk, vermerk_pruefung, prüfvermerk
      </Typography>
      <Grid container sx={{ margin: "1rem 0" }} spacing={2}>
        {_.map(filters, (filter, index) => (
          <Grid key={index}>
            <Chip onDelete={() => removeFilter(filter)} label={filter} variant={"outlined"} />
          </Grid>
        ))}
      </Grid>
      <Stack
        direction={"row"}
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center"
        }}>
        <TextField
          placeholder={"Filterwort"}
          value={newFilter}
          onChange={(event) => setNewFilter(event.target.value)}
        />
        <IconButton disabled={newFilter === ""} onClick={addFilter}>
          <Add />
        </IconButton>
      </Stack>
      <ButtonLoading
        onClick={handleSaveFilters}
        isLoading={isLoading}
        variant={"contained"}
        disabled={_.isEqual(filters, initialFilters)}
      >
        Speichern
      </ButtonLoading>
    </ContentBox>
  );
}
